'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Resource = require('./resource');
var SimpleLogger = require('./simple-logger');

// Configuration provides access to the configuration for a given environment
//
// It provides a method substituteConfigurationItems() that replaces all references
// to things like '@itemName' with the corresponding value from the configuration
// and is used to resolve such names in REST routes.

var Configuration = function () {
    function Configuration(environment, configService, authenticationService, xmlHttpRequest, config) {
        _classCallCheck(this, Configuration);

        this.environment = environment;
        this.configService = configService;
        this.authenticationService = authenticationService;
        this.xmlHttpRequest = xmlHttpRequest;
        this.config = config;

        this.keys = {};
        this.values = undefined;

        this.log = new SimpleLogger();

        if (configService === null) {
            this.log.warn('Configuration("' + environment.name + '").constructor() - ' + ' the configuration will be empty, because the configService parameter' + ' was provided as null. If desired, you can use Environment.setConfiguration() ' + ' to specify key/value pairs.');

            this.values = {};
        }

        this.chatty = environment.chatty;

        // this.getResources();
    }

    _createClass(Configuration, [{
        key: 'verbose',
        value: function verbose(value) {
            if (value === undefined) {
                value = true;
            }

            this.chatty = value;

            return this;
        }
    }, {
        key: 'setValues',
        value: function setValues(values) {
            this.values = values;
        }
    }, {
        key: 'substituteConfigurationItems',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(text) {
                var originalText, prefix, ITEM, match, name, value, _prefix, message;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                originalText = text;
                                prefix = 'Configuration("' + this.environment.name + '").substituteConfigurationItems("' + text + '")';


                                if (this.chatty) {
                                    this.log.debug(prefix);
                                }

                                this.values = this.config;

                                ITEM = /@([\w\.]+)\b/;
                                match = void 0;

                            case 6:
                                if (!((match = text.match(ITEM)) !== null)) {
                                    _context.next = 17;
                                    break;
                                }

                                name = match[1];
                                value = this.values[name];
                                _prefix = 'Configuration("' + this.environment.name + '").substituteConfigurationItems()';

                                if (value) {
                                    _context.next = 14;
                                    break;
                                }

                                message = _prefix + ' - the configuration is missing item ' + name + ' required' + (' in string \'' + originalText + '\'');


                                this.log.scream(message);

                                throw message;

                            case 14:

                                text = text.replace(ITEM, value);
                                _context.next = 6;
                                break;

                            case 17:

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - returning "' + text + '"');
                                }

                                return _context.abrupt('return', text);

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function substituteConfigurationItems(_x) {
                return _ref.apply(this, arguments);
            }

            return substituteConfigurationItems;
        }()
    }, {
        key: 'getItem',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(name) {
                var ignoreMissingItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var value, message;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(this.values === undefined)) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return this.getConfigurationValues();

                            case 3:
                                value = this.values[name];


                                if (value === undefined && !ignoreMissingItems) {
                                    message = 'Configuration("' + this.environment.name + '").getItem()' + (' - the configuration does not contain an item named \'' + name + '\'');


                                    this.log.scream(message);
                                }

                                return _context2.abrupt('return', value);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getItem(_x2) {
                return _ref2.apply(this, arguments);
            }

            return getItem;
        }()

        // Implementation details ...

    }, {
        key: 'getResources',
        value: function getResources() {
            var configResource = new Resource('configuration', this).baseUrl(this.configService).service('configurations').noAuthentication();

            this.environment.resources['configuration'] = configResource;

            this.login = new Resource('authentication', this).baseUrl(this.authenticationService).service('sessions').noAuthentication();

            this.environment.resources['authentication'] = this.login;
        }
    }, {
        key: 'profileConfiguration',
        value: function profileConfiguration(value) {
            if (value === undefined) {
                value = true;
            }

            this.getResources();

            this.environment.resources['configuration'].profile(value);

            return this;
        }
    }, {
        key: 'profileAuthentication',
        value: function profileAuthentication(value) {
            if (value === undefined) {
                value = true;
            }

            this.getResources();

            this.environment.resources['authentication'].profile(value);

            return this;
        }
    }, {
        key: 'getConfigurationValues',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var prefix;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                prefix = 'Configuration.getConfigurationValues()';


                                this.getResources();

                                return _context3.abrupt('return', this.config);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getConfigurationValues() {
                return _ref3.apply(this, arguments);
            }

            return getConfigurationValues;
        }()
    }]);

    return Configuration;
}();

module.exports = Configuration;


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/resource/lib/configuration.js
// module id = 608
// module chunks = 4